import apiClient from "QueryClient/axiosClient";
export const getHomeData = async () => {
  const response = await apiClient.get("/oneGradSlot/getHomePageMetrics");
  return response.data;
};
